import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=d5039c8a&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d5039c8a')) {
      api.createRecord('d5039c8a', component.options)
    } else {
      api.reload('d5039c8a', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=d5039c8a&", function () {
      api.rerender('d5039c8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-278xmOuTKBlO8/JS/offershelp.vue"
export default component.exports